import './quiz';
(function () {
  'use strict';

  var CFG = window.LEAD_CONFIG || {};
  var I18N = CFG.i18n || {};
  var MQ_DESKTOP = window.matchMedia('(min-width: 901px)');
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- аналітика ---------- */
  function track(event, data) {
    var payload = Object.assign({ event: event, partner: CFG.partner || '' }, data || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') { window.gtag('event', event, payload); }
    if (window.console && console.debug) { console.debug('[track]', event, payload); }
  }

  /* ---------- UTM / gclid ----------
     Значення зберігаються в localStorage (переживають закриття вкладки/сесії,
     щоб атрибуція не губилась, якщо лід повертається без UTM у наступний візит).
     Кожен параметр — окремий ключ localStorage з тим самим ім'ям (utm_campaign,
     utm_source, ...), щоб додавання нового параметра не вимагало нового коду:
     достатньо дописати його в UTM_KEYS. */
  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'loc_id'];
  function isMacro(v) { return /^\{.*\}$/.test(v || ''); } // нерозгорнутий макрос {keyword}

  function captureCampaign() {
    var qs = new URLSearchParams(location.search);
    UTM_KEYS.forEach(function (k) {
      var v = qs.get(k);
      if (v && !isMacro(v) && v.length <= 300) {
        try { localStorage.setItem(k, String(v)); } catch (e) { }
      }
    });
  }
  captureCampaign();

  function readCampaign() {
    var store = {};
    UTM_KEYS.forEach(function (k) {
      var v;
      try { v = localStorage.getItem(k); } catch (e) { v = null; }
      if (v) { store[k] = v; }
    });
    return store;
  }

  function fillHidden(form) {
    var campaign = readCampaign();
    UTM_KEYS.forEach(function (k) {
      var el = form.querySelector('[name="' + k + '"]');
      if (el) { el.value = campaign[k] || ''; }
    });
    var pu = form.querySelector('[name="page_url"]'); if (pu) { pu.value = location.href; }
    var pn = form.querySelector('[name="partner"]'); if (pn) { pn.value = CFG.partner || ''; }
  }

  /* ============================================================
     ФОРМА — єдина, переноситься між hero (десктоп) і фіналом (мобільний)
     ============================================================ */
  var tpl = $('#leadFormTpl');
  var formCard = tpl ? tpl.content.firstElementChild.cloneNode(true) : null;
  var heroSlot = $('#heroFormSlot');
  var finalSlot = $('#finalFormSlot');

  function placeForm() {
    if (!formCard) return;
    var target = MQ_DESKTOP.matches ? heroSlot : finalSlot;
    if (target && formCard.parentNode !== target) { target.appendChild(formCard); }
  }
  placeForm();
  if (MQ_DESKTOP.addEventListener) { MQ_DESKTOP.addEventListener('change', placeForm); }
  else if (MQ_DESKTOP.addListener) { MQ_DESKTOP.addListener(placeForm); }

  var form = formCard ? $('.js-lead-form', formCard) : null;
  if (form) { fillHidden(form); }

  /* ---------- телефон: маска +380 (XX) XXX-XXXX ---------- */
  var phoneInput = form ? form.querySelector('[name="phone"]') : null;

  function formatPhone(value) {
    var d = value.replace(/\D/g, '');
    if (d.indexOf('380') === 0) { d = d.slice(3); }
    d = d.substring(0, 9);

    var result = '+380 ';
    if (d.length > 0) { result += '(' + d.substring(0, 2); }
    if (d.length >= 2) { result += ') ' + d.substring(2, 5); }
    if (d.length >= 5) { result += '-' + d.substring(5, 9); }
    return result;
  }

  if (phoneInput) {
    phoneInput.value = '+380 ';

    phoneInput.addEventListener('input', function () {
      this.value = formatPhone(this.value);
    });

    phoneInput.addEventListener('keydown', function (e) {
      var isDelete = e.key === 'Backspace' || e.key === 'Delete';
      if (!isDelete) return;

      if (this.selectionStart === 0 && this.selectionEnd === this.value.length) {
        e.preventDefault();
        this.value = '+380 ';
        return;
      }
      if (this.selectionStart <= 4) { e.preventDefault(); return; }

      e.preventDefault();
      var raw = this.value.replace(/\D/g, '');
      var clean = raw.indexOf('380') === 0 ? raw.slice(3) : raw;
      clean = clean.slice(0, -1);
      this.value = formatPhone('+380' + clean);
    });
  }

  /* ---------- валідація ---------- */
  function digits(s) { return String(s || '').replace(/\D+/g, ''); }
  function showErr(input, key, show) {
    input.setAttribute('aria-invalid', show ? 'true' : 'false');
    var err = form.querySelector('[data-err="' + key + '"]');
    if (err) { err.classList.toggle('show', show); }
  }
  var isValidName = function (v) { return /^[a-zA-Zа-яА-ЯіІїЇєЄґҐ\s'-]{2,}$/.test((v || '').trim()); };
  var isValidPhone = function (v) { return /^380\d{9}$/.test(digits(v)); };
  var isValidText = function (v) { return (v || '').trim().length >= 2; };

  function validate() {
    var ok = true;
    var name = form.querySelector('[name="name"]');
    var phone = form.querySelector('[name="phone"]');
    var message = form.querySelector('[name="message"]');

    if (!isValidName(name.value)) { showErr(name, 'name', true); ok = false; } else { showErr(name, 'name', false); }
    if (!isValidPhone(phone.value)) { showErr(phone, 'phone', true); ok = false; } else { showErr(phone, 'phone', false); }
    if (message) {
      if (!isValidText(message.value)) { showErr(message, 'message', true); ok = false; }
      else { showErr(message, 'message', false); }
    }
    return ok;
  }

  /* ---------- відправка ліда (оригінальна логіка: одразу, з fallback-заглушкою) ---------- */
  function sendLead(data) {
    if (CFG.endpoint) {
      return fetch(CFG.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      }).then(function (r) {
        if (!r.ok) throw new Error('bad status ' + r.status);
        return true;
      });
    }
    // заглушка до підключення реального ендпоінту
    try {
      var arr = JSON.parse(localStorage.getItem('ap_leads') || '[]');
      arr.push(data); localStorage.setItem('ap_leads', JSON.stringify(arr));
    } catch (e) { }
    console.log('[LEAD] (заглушка, endpoint не задано)', data);
    return Promise.resolve(true);
  }

  /* ---------- reCAPTCHA v3: якщо CFG.recaptchaSiteKey порожній — повністю no-op ---------- */
  function getRecaptchaToken() {
    if (!CFG.recaptchaSiteKey || typeof window.grecaptcha === 'undefined') {
      return Promise.resolve(''); 
    }
    return new Promise(function (resolve) {
      window.grecaptcha.ready(function () {
        window.grecaptcha.execute(CFG.recaptchaSiteKey, { action: 'lead_submit' })
          .then(resolve)
          .catch(function () { resolve(''); });
      });
    });
  }

  function verifyRecaptcha(token) {
    if (!CFG.recaptchaSiteKey) return Promise.resolve(true);

    var body = new URLSearchParams({
      action: 'advokat_verify_recaptcha',
      nonce: CFG.recaptchaNonce || '',
      token: token
    });

    return fetch(CFG.recaptchaVerifyUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (result) { return !!(result && result.success); })
      .catch(function () { return false; });
  }

  if (form) {
    var submitBtn = form.querySelector('.js-submit');
    var submitLabelDefault = submitBtn ? submitBtn.textContent : '';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.querySelector('[name="company"]').value) { return; }
      if (!validate()) {
        var firstErr = form.querySelector('[aria-invalid="true"]');
        if (firstErr) firstErr.focus();
        return;
      }

      submitBtn.disabled = true;
      submitBtn.textContent = I18N.sending || submitLabelDefault;

      getRecaptchaToken().then(function (token) {
        return verifyRecaptcha(token).then(function (ok) {
          if (!ok) { throw new Error('recaptcha_failed'); }

          fillHidden(form);
          var fd = new FormData(form);
          var data = {}; fd.forEach(function (v, k) { data[k] = v; });
          delete data.company;
          data.phone = digits(data.phone);
          data.recaptcha_token = token;

          var leadRef = 'L-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 7);
          data.lead_ref = leadRef;
          try { sessionStorage.setItem('ap_lead_ref', leadRef); } catch (e) {}

          return sendLead(data);
        });
      }).then(function () {
        track('lead_submit', {});
        try { localStorage.setItem('ap_lead', '1'); } catch (e) {}
        location.href = CFG.thanksUrl || '/';
      }).catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = submitLabelDefault;
        alert((I18N.connError || I18N.sendError || 'Не вдалося надіслати. Спробуйте ще раз або зателефонуйте: ') + (CFG.phone || ''));
      });
    });
  }

  /* ============================================================
     КЛІК ПО ТЕЛЕФОНУ — конверсія, дедуп 30 хв
     ============================================================ */
  function onTel() {
    try { sessionStorage.setItem('ap_tel', '1'); } catch (e) { }
    var now = Date.now(), last = 0;
    try { last = parseInt(localStorage.getItem('ap_tel_ts') || '0', 10); } catch (e) { }
    if (now - last > 30 * 60 * 1000) {
      track('tel_click', {});
      try { localStorage.setItem('ap_tel_ts', String(now)); } catch (e) { }
    }
  }
  function bindTel() {
    $$('.js-tel').forEach(function (a) {
      if (a.__telBound) return; a.__telBound = true;
      a.addEventListener('click', onTel);
    });
  }
  bindTel();

  /* ============================================================
     ЛИПКИЙ БАР (мобільний)
     ============================================================ */
  var body = document.body;
  var formVisible = false;
  var scrolledPast = false;
  var kbOpen = false;

  function refreshSticky() {
    var show = !MQ_DESKTOP.matches && scrolledPast && !formVisible && !kbOpen && !body.classList.contains('exit-open');
    body.classList.toggle('sticky-on', show);
    var bar = $('#stickyBar');
    if (bar) bar.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  window.addEventListener('scroll', function () {
    scrolledPast = window.pageYOffset > 400;
    refreshSticky();
  }, { passive: true });

  if (formCard && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      formVisible = entries[0].isIntersecting;
      refreshSticky();
    }, { threshold: 0.2 });
    io.observe(formCard);
  }

  document.addEventListener('focusin', function (e) {
    if (e.target.matches('input, textarea')) { kbOpen = true; refreshSticky(); }
  });
  document.addEventListener('focusout', function (e) {
    if (e.target.matches('input, textarea')) { kbOpen = false; refreshSticky(); }
  });
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function () {
      kbOpen = window.visualViewport.height < window.innerHeight * 0.75;
      refreshSticky();
    });
  }

  /* ============================================================
     ПОПАП ПРИ ВИХОДІ
     ============================================================ */
  var pop = $('#exitPop');
  var loadTs = Date.now();
  var HALF, THIRD;
  function recalcDepths() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    HALF = h * 0.5; THIRD = h * 0.34;
  }
  recalcDepths();
  window.addEventListener('resize', recalcDepths);

  function eligible() {
    if (!pop) return false;
    if (body.classList.contains('exit-open')) return false;
    if (Date.now() - loadTs < 12000) return false;
    if (document.activeElement && document.activeElement.matches && document.activeElement.matches('input, textarea')) return false;
    try { if (localStorage.getItem('ap_lead') === '1') return false; } catch (e) { }
    try { if (sessionStorage.getItem('ap_tel') === '1') return false; } catch (e) { }
    try { if (sessionStorage.getItem('ap_exit_shown') === '1') return false; } catch (e) { }
    try {
      var last = parseInt(localStorage.getItem('ap_exit_ts') || '0', 10);
      if (Date.now() - last < 72 * 3600 * 1000) return false;
    } catch (e) { }
    return true;
  }

  function openPop() {
    if (!eligible()) return;
    body.classList.add('exit-open');
    pop.classList.add('open');
    pop.setAttribute('aria-hidden', 'false');
    refreshSticky();
    try { sessionStorage.setItem('ap_exit_shown', '1'); } catch (e) { }
    try { localStorage.setItem('ap_exit_ts', String(Date.now())); } catch (e) { }
    track('exit_popup', {});
  }
  function closePop() {
    body.classList.remove('exit-open');
    pop.classList.remove('open');
    pop.setAttribute('aria-hidden', 'true');
    refreshSticky();
  }

  if (pop) {
    $$('[data-exit-close]', pop).forEach(function (el) { el.addEventListener('click', closePop); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('open')) closePop(); });

    document.addEventListener('mouseout', function (e) {
      if (!MQ_DESKTOP.matches) return;
      if (e.clientY <= 0 && !e.relatedTarget) openPop();
    });

    var backUsed = false;
    try { history.pushState({ ap: 1 }, '', location.href); } catch (e) { }
    window.addEventListener('popstate', function () {
      if (MQ_DESKTOP.matches) return;
      if (!backUsed && eligible()) {
        backUsed = true;
        openPop();
      }
    });

    var lastY = window.pageYOffset, lastT = Date.now();
    window.addEventListener('scroll', function () {
      if (MQ_DESKTOP.matches) return;
      var y = window.pageYOffset, t = Date.now();
      var dy = lastY - y, dt = t - lastT;
      if (dt < 550 && dy > 400 && lastY > THIRD) openPop();
      if (dt > 120) { lastY = y; lastT = t; }
    }, { passive: true });

    var idleTimer = null;
    function resetIdle() {
      if (MQ_DESKTOP.matches) return;
      if (idleTimer) clearTimeout(idleTimer);
      idleTimer = setTimeout(function () {
        if (window.pageYOffset > HALF) openPop();
      }, 40000);
    }
    ['scroll', 'touchstart', 'click', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, resetIdle, { passive: true });
    });
    resetIdle();

    var card = $('#exitPopCard'), ty0 = null;
    if (card) {
      card.addEventListener('touchstart', function (e) { ty0 = e.touches[0].clientY; }, { passive: true });
      card.addEventListener('touchmove', function (e) {
        if (ty0 !== null && e.touches[0].clientY - ty0 > 70) { closePop(); ty0 = null; }
      }, { passive: true });
      card.addEventListener('touchend', function () { ty0 = null; });
    }
  }

  refreshSticky();

  /* ============================================================
     МОБІЛЬНИЙ РЕМІНДЕР ПРО ЗАСТОСУНОК (лише сторінка подяки —
     no-op, якщо #appReminder немає в розмітці).
     ============================================================ */
  function initMobileReminder() {
    var reminder = document.getElementById('appReminder');
    if (!reminder) return;

    var iosLink = document.getElementById('app-link-ios');
    var androidLink = document.getElementById('app-link-android');
    var closeBtn = reminder.querySelector('button');

    var ua = navigator.userAgent || navigator.vendor || window.opera;
    var isIOS = /iPad|iPhone|iPod/.test(ua);
    var isAndroid = /android/i.test(ua);

    if (isIOS) {
      if (iosLink) { iosLink.classList.remove('hidden'); }
      else { reminder.style.display = 'none'; return; }
    } else if (isAndroid) {
      if (androidLink) { androidLink.classList.remove('hidden'); }
      else { reminder.style.display = 'none'; return; }
    } else {
      reminder.style.display = 'none';
      return;
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', function () { reminder.style.display = 'none'; });
    }
  }
  initMobileReminder();
})();